import { GraphQLError } from 'graphql';

import { TRANSLATIONS as text } from '../../translations';

const errorMapper = (error, errorMessages) => {
  if (!error) {
    return null;
  }

  if (error.networkError) {
    return text.errors.generic;
  }

  if (error instanceof GraphQLError) {
    if (error.extensions?.errorCode === 'UnknownErrorCode') {
      return text.errors.Unknown;
    }
  }

  const errorFromCode = error?.graphQLErrors?.reduce((_acc, err) => {
    if (!errorMessages) {
      return null;
    }
    if (errorMessages[err.extensions.errorCode]) {
      return errorMessages[err.extensions.errorCode];
    }
    return null;
  }, null);

  if (errorFromCode) {
    return errorFromCode;
  }

  return text.errors.generic;
};

export default errorMapper;
